import React from 'react'
import single from './imageuploader.module.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile, faTimes } from '@fortawesome/free-solid-svg-icons';


const Single = ({ handleChange, handleRemoveImage, e, singlePreview, setSinglePreview, }) => {
  const singleImageChange = (e) => {
    console.log(handleChange)
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      const url = URL.createObjectURL(file)
      setSinglePreview(url);
      handleChange(e)
    } 
  };
  const handleRemove = () => {
    handleRemoveImage()
    setSinglePreview("")
  }
  return (
    <div className={single.uploadWrapper}>
      <label htmlFor={e}>Image</label>
      <input 
        onChange={singleImageChange}
        id={e}
        name={e}
        type= "file"
        accept='image/*'
        className={single.input}
      />

      <div className={single.fleximg}>
        <div className={single.preview}>
          {singlePreview && 
            <div className={single.imageWrap}>
              <img
                src={singlePreview}
                alt="Preview"
                style={{ width: "200px", borderRadius: "8px", border: "1px solid #ccc" }}
              />
              <span className={single.icon}>
                <FontAwesomeIcon icon={faTimes} onClick={handleRemove}/>
              </span>
            </div>
          }
        </div>

        {!singlePreview? 
          <label htmlFor={e}>Browse</label> : 
          <label htmlFor={e} className={single.add}>
          <FontAwesomeIcon icon={faFile}/>
        </label>
        }
      </div>
    </div>
  )
}

export default Single
